export const SET_VALIDATION_ERRORS = 'SET_VALIDATION_ERRORS'
export const SET_COMPANY = 'SET_COMPANY'
export const SET_COMPANY_CONTACT_DETAILS = 'SET_COMPANY_CONTACT_DETAILS'
export const SET_COMPANY_ADDRESSES = 'SET_COMPANY_ADDRESSES'
export const UPDATE_COMPANY_PRIMARY_ADDRESS = 'UPDATE_COMPANY_PRIMARY_ADDRESS'
export const SET_PRIMARY_ADDRESS = 'SET_PRIMARY_ADDRESS'
export const SET_VISIT_ADDRESS = 'SET_VISIT_ADDRESS'
export const SET_POST_ADDRESS = 'SET_POST_ADDRESS'
export const SET_SELF_SERVICE_STATUS = 'SET_SELF_SERVICE_STATUS'

export default {
  SET_VALIDATION_ERRORS,
  SET_COMPANY,
  UPDATE_COMPANY_PRIMARY_ADDRESS,
  SET_COMPANY_CONTACT_DETAILS,
  SET_COMPANY_ADDRESSES,
  SET_PRIMARY_ADDRESS,
  SET_VISIT_ADDRESS,
  SET_POST_ADDRESS,
  SET_SELF_SERVICE_STATUS
}



// WEBPACK FOOTER //
// ./src/store/modules/company/mutation-types.js